import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';

export default class Contact extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			show: 'apply',
      name: '',
			email: '',
			address: '',
			facebook: '',
			message: '',
		};
		this.handleChange = this.handleChange.bind(this);
		this.processDetails = this.processDetails.bind(this);
  };

  
  
  async componentDidMount() {
		document.title = "Apply - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		const params = new URLSearchParams();
		params.append( 'profile', getUser.user.username );
		const x = await postApi('/api/v2/profile', params);
		this.setState({status: true, email: x.data.User.email});
	}

	componentWillUnmount() {
	}

	handleChange(event) {
		//var isChecked = event.target.checked;
		var item = event.target.value;
		if( event.target.name === "name" ) this.setState({name:item});
		if( event.target.name === "email" ) this.setState({email:item});
		if( event.target.name === "address" ) this.setState({address:item});
		if( event.target.name === "facebook" ) this.setState({facebook:item});
		if( event.target.name === "message" ) this.setState({message:item});
	}

	async processDetails(event) {
		event.preventDefault();
		this.setState({show: 'complete'});

		const params = new URLSearchParams();
		params.append('name', this.state.name);
		params.append('email', this.state.email);
		params.append('address', this.state.address);
		params.append('facebook', this.state.facebook);
		params.append('message', this.state.message);

		await putApi('/api/v2/apply', params);
	}
	

	render() {
		const user = this.context;
		return (
			<>
				{this.state.status &&
					<>
						<div className="contact">
							<div className="contact-background"></div>
						</div>
						<div className="article">
							<Row className="gx-0">
								<Col className="contact-header">
									<h1>Apply to DJ</h1>
								</Col>
							</Row>
							
							<Row className="gx-0">
								<Col md={{span: 6, offset: 2}} >

									<h2>What we do / offer</h2>
									<ul>
										<li>Stream up to 320kbps audio</li>
										<li>Stream up to 4k video</li>
										<li>We run and maintain our own dedicated server</li>
										<li>All systems are maintained inhouse</li>
										<li>Help and support</li>
										<li>Easy to use booking system</li>
										<li>Automatic audio upload onto our website of your dj set</li>
										<li>Your very own dj profile page</li>
										<li>Availability to stream to multiple rooms on our website (coming soon)</li>
										<li>Automatic multistream to multiple platforms</li>
										<li>Twitch Chat Integration</li>
										<li>OBS Templates</li>
										<li>+ many more</li>
									</ul>

									
									<h3>Apply</h3>
									
									{user.user.access.verified ?
										<>
										</>
									:
										<>
										</>
									}
									{this.state.show==='apply' ?

										<Form id="contact-form" onSubmit={this.processDetails}>
											<div>
												{!user.user.access.verified &&
													<>
														Please register for an account before applying for a DJ position<br /><br />
														<ButtonGroup size="sm">
															<Link to="/login"><Button size="sm">Login</Button></Link>
															<Link to="/signup"><Button size="sm">Signup</Button></Link>
														</ButtonGroup><br /><br />
													</>
												}
												<label>Full name</label>
												<InputGroup className="mb-2">
													<FormControl name="name" id="name" onChange={this.handleChange} value={this.state.name} placeholder="Full Name" aria-label="Name" aria-describedby="basic-addon1" required disabled={!user.user.access.verified} />
												</InputGroup>
												<label>Email Address</label>
												<InputGroup className="mb-2">
													<FormControl name="email" id="email" onChange={this.handleChange} value={this.state.email} placeholder="Email" aria-label="Email" aria-describedby="basic-addon1" required disabled={!user.user.access.verified} />
												</InputGroup>
												<label>Please provide a link to where we can check out your mixes</label>
												<InputGroup className="mb-2">
													<FormControl name="address" id="address" onChange={this.handleChange} value={this.state.address} placeholder="Channel address" aria-label="Address" aria-describedby="basic-addon1" required disabled={!user.user.access.verified} />
												</InputGroup>
												<label>Facebook personal profile page</label>
												<InputGroup className="mb-2">
													<FormControl name="facebook" id="facebook" onChange={this.handleChange} value={this.state.facebook} placeholder="Facebook Profile" aria-label="Facebook" aria-describedby="basic-addon1" required disabled={!user.user.access.verified} />
												</InputGroup>
												<label>Description about your self and what type of music you play</label>
												<InputGroup className="mb-2">
													<Form.Control as="textarea" rows="6" name="message" id="message" onChange={this.handleChange} value={this.state.message} placeholder="Message" aria-label="Message" aria-describedby="basic-addon1" required disabled={!user.user.access.verified} />
												</InputGroup>

											</div>
											<input type="hidden" name="cfa-pagelayer-id" />
											<input type="hidden" name="cfa-post-id" value="25" />

											<div>
												<Button size="sm" onClick={this.processDetails} disabled={!user.user.access.verified}>Apply</Button>
											</div>
										</Form>
									:
										<>
											<p>Thank you for contacting support and we will get back to you by email as soon as possible</p>
											<p>Contact Details:</p>
											<p>Name: {this.state.name}</p>
											<p>Email: {this.state.email}</p>
											<p>Message: {this.state.message}</p>
										</>
									}
								</Col>
							</Row>
						</div>
					</>
				}
			</>
		);
	}
}
